export default {
  path: 'excavation-service/work-orders/active',
  name: 'ExcavationActiveWorkOrders',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/ExcavationWorkOrdersIndex')
}
